import React, {useState, useEffect} from 'react'
import {Link} from 'react-router-dom'
import {
    useDispatch,
    useSelector
} from 'react-redux'
import classnames from 'classnames'
import {
    Folder,
    Trash2,
    Edit,
    FolderPlus
} from 'react-feather'
import {
    InputGroup,
    InputGroupAddon,
    Input,
    Button,
    Card,
    CardBody,
    Row,
    Col,
    Spinner
} from 'reactstrap'
import CustomPagination from '@src/views/components/pagination/CustomPagination'
import AddToFav from '@src/views/components/AddToFav'
import {
    getFavFolderList,
    deleteFavFolder,
    deleteFavFolderReset
} from '@store/actions/BrandActions'
import queryString from "query-string"
import {
    confirmAlert,
    successAlert,
    errorAlert
} from '@src/views/components/CustomAlerts'

const Favourites = () => {
    const dispatch = useDispatch()

    const [openAddToFav, setOpenAddToFav] = useState(false)
    const [activeFolder, setActiveFolder] = useState(null)
    const [searchFolderValue, setSearchFolderValue] = useState('')
    const [activePage, setActivePage] = useState('Favorites')

    const {
        favFolderListLoading,
        favFolderListData,
        favFolderListError,

        favFolderDeleteLoading,
        favFolderDeleteData,
        favFolderDeleteError
    } = useSelector(state => state.brandReducer)

    const handleError = (error) => {
        if (error?.response?.status) {
            errorAlert(error?.response?.data?.message || 'Bad Request')
        } else {
            errorAlert(error?.msg || 'Something went wrong')
        }
    }

    useEffect(() => {
        dispatch(getFavFolderList(``))
    }, [])

    useEffect(() => {
        if (favFolderDeleteData?.status) {
            dispatch(deleteFavFolderReset())
            dispatch(getFavFolderList(``))
            successAlert(favFolderDeleteData?.msg)
        }
        if (favFolderDeleteError) {
            dispatch(deleteFavFolderReset())
            handleError(favFolderDeleteError)
        }
        if (favFolderListError) {
            handleError(favFolderListError)
        }
    }, [
        favFolderDeleteData,
        favFolderDeleteError,
        favFolderListError
    ])

    const onUpdateFolder = (folder) => {
        setOpenAddToFav(true)
        setActiveFolder(folder)
    }

    const onDeleteFolder = async (folder) => {
        const isConfirmed = await confirmAlert('Delete?', 'Do you really want to delete?')
        if (isConfirmed) {
            dispatch(deleteFavFolder({
                id: folder.id
            }))
        }
    }

    const handeSearchFolders = () => {
        dispatch(getFavFolderList({
            folder_name: searchFolderValue
        }))
    }

    const handeResetSearch = () => {
        setSearchFolderValue('')
        dispatch(getFavFolderList(``))
    }

    const handleCustomPagination = (pageUrl) => {
        const parsed = queryString.parseUrl(pageUrl)
        if (parsed.query?.page) {
            dispatch(getFavFolderList({
                page: parsed.query.page
            }))
        }
    }

    const onEnterSearch = (e) => {
        if (e.key === 'Enter') {
            handeSearchFolders()
        }
    }

    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-2 flex-wrap">
                <h3 className="mr-2">Favorites</h3>
                <Button
                    className='h-100'
                    color='primary'
                    onClick={() => {
                        setOpenAddToFav(true)
                    }}
                >
                    <FolderPlus size={16}/>
                    <span> Create New Folder</span>
                </Button>
            </div>
            <Card>
                <CardBody>
                    <Row>
                        <Col md="6">
                            <InputGroup size='lg' className="input-group-with-tabs-c">
                                <InputGroupAddon addonType='append'>
                                    <Button
                                        className={classnames({
                                            'active-tab': activePage === 'All'
                                        })}
                                        onClick={() => setActivePage('All')}
                                        tag={Link}
                                        to={`/dashboard/brands/nutritions`}
                                        color='primary'
                                        outline>
                                        All
                                    </Button>
                                </InputGroupAddon>
                                <InputGroupAddon addonType='append'>
                                    <Button
                                        className={classnames({
                                            'active-tab': activePage === 'My RDs'
                                        })}
                                        onClick={() => setActivePage('My RDs')}
                                        tag={Link}
                                        to={`/dashboard/brands/my-rds`}
                                        color='primary'
                                        outline>
                                        My RDs
                                    </Button>
                                </InputGroupAddon>
                                <InputGroupAddon addonType='append'>
                                    <Button
                                        className={classnames({
                                            'active-tab': activePage === 'Favorites'
                                        })}
                                        onClick={() => setActivePage('Favorites')}
                                        tag={Link}
                                        to={`/dashboard/brands/favorite-folders`}
                                        color='primary'
                                        outline>
                                        Favorites
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </Col>
                        <Col md="6">
                            <InputGroup size='lg' className="mt-2 mt-md-0">
                                <Input placeholder='Search By Name' value={searchFolderValue} onChange={(e) => setSearchFolderValue(e.target.value)} onKeyDown={onEnterSearch}/>
                                <InputGroupAddon addonType='append'>
                                    <Button color='primary' onClick={handeSearchFolders} outline>
                                        Search
                                    </Button>
                                </InputGroupAddon>
                                <InputGroupAddon addonType='append'>
                                    <Button color='primary' onClick={handeResetSearch} outline>
                                        Reset
                                    </Button>
                                </InputGroupAddon>
                            </InputGroup>
                        </Col>
                        <Col md="6" className="text-md-right text-center mt-md-0 mt-2">
                        </Col>
                    </Row>
                </CardBody>
            </Card>
            {(favFolderListLoading || favFolderDeleteLoading) ? (
                <div className="w-100 my-4 text-center"><Spinner color='primary'/></div>
            ) : (
                <>
                    {favFolderListData?.data?.length > 0 && (
                        <div className="ecommerce-application">
                            <Row>
                                {favFolderListData?.data.map((item, i) => (
                                    <Col sm="6" md="4" key={`fav-folder-${i}`}>
                                        <Card>
                                            <CardBody className="d-flex align-items-center justify-content-between">
                                                <div className="d-flex align-items-center">
                                                    <Folder
                                                        className='text-secondary mr-1'
                                                        size={20}
                                                    />
                                                    <h5 className='mb-0'>
                                                        <Link to={`/dashboard/brands/favorite-folders/${item.id}`}>
                                                            {item.folder_name}
                                                        </Link>
                                                    </h5>
                                                </div>
                                                <div className="min-60px">
                                                    <Edit
                                                        className='cursor-pointer'
                                                        size={20}
                                                        onClick={() => onUpdateFolder(item)}
                                                    />
                                                    <Trash2
                                                        className='ml-1 cursor-pointer text-danger'
                                                        size={20}
                                                        onClick={() => onDeleteFolder(item)}
                                                    />
                                                </div>
                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                            <CustomPagination pageLinks={favFolderListData?.pages} onPaginationClick={handleCustomPagination}/>
                        </div>
                    )}
                    {favFolderListData?.data?.length === 0 && (
                        <div className="w-100 my-4 text-center">
                            <h4>Record doesn't exists</h4>
                        </div>
                    )}
                </>
            )}

            <AddToFav
                title='Create New Folder'
                isOpen={openAddToFav}
                onClose={() => {
                    setOpenAddToFav(false)
                    setActiveFolder(null)
                }}
                hideListing={true}
                onFolderCreate={() => {
                    dispatch(getFavFolderList(``))
                    setActiveFolder(null)
                }}
                folderData={activeFolder}
            />
        </>
    )
}

export default Favourites
